import React from 'react';
import { motion } from 'framer-motion';

const Footer: React.FC = () => {
    const footerLinks = [
        {
            title: 'Product',
            links: [
                { name: 'Features', href: '#' },
                { name: 'Portfolio', href: '#portfolio' },
                { name: 'Watchlist', href: '#watchlist' },
            ]
        },
        {
            title: 'Company',
            links: [
                { name: 'About', href: '#' },
                { name: 'Careers', href: '#' },
                { name: 'Blog', href: '#' },
            ]
        },
        {
            title: 'Resources',
            links: [
                { name: 'Documentation', href: '#' },
                { name: 'Support', href: '#' },
                { name: 'Security', href: '#' },
            ]
        },
    ];

    const socialLinks = [
        {
            name: 'Twitter',
            href: '#',
            icon: (
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                </svg>
            )
        },
        {
            name: 'GitHub',
            href: '#',
            icon: (
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
                </svg>
            )
        },
        {
            name: 'Discord',
            href: '#',
            icon: (
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path fillRule="evenodd" d="M18.93 5.34a16.89 16.89 0 00-4.07-1.24.06.06 0 00-.07.03c-.18.33-.39.76-.53 1.09a15.66 15.66 0 00-4.51 0c-.14-.34-.35-.76-.54-1.09-.01-.02-.04-.03-.07-.03-1.59.2-2.99.62-4.07 1.24-.01 0-.02.01-.03.02-2.57 3.77-3.27 7.45-2.93 11.09 0 .02.01.04.03.05 1.7 1.23 3.33 1.97 4.95 2.46.03.01.06 0 .07-.02.42-.55.79-1.13 1.11-1.74.02-.04 0-.08-.04-.09-.53-.2-1.04-.44-1.52-.71-.04-.02-.04-.08-.01-.11.1-.08.21-.16.31-.24.02-.01.04-.01.06-.01 3.15 1.42 6.57 1.42 9.7 0 .02 0 .04 0 .06.01.1.08.21.17.32.25.04.03.03.09-.01.11-.49.28-.99.51-1.52.71-.04.01-.05.06-.04.09.32.61.69 1.2 1.11 1.74.03.02.06.02.09.01 1.62-.49 3.26-1.23 4.95-2.46.02-.01.03-.03.03-.05.4-4.12-.68-7.76-2.89-11.09 0-.01-.02-.02-.04-.02zM8.67 14.97c-.97 0-1.78-.88-1.78-1.97 0-1.08.79-1.97 1.78-1.97s1.8.89 1.78 1.97c0 1.08-.79 1.97-1.78 1.97zm6.58 0c-.97 0-1.78-.88-1.78-1.97 0-1.08.79-1.97 1.78-1.97s1.8.89 1.78 1.97c0 1.08-.79 1.97-1.78 1.97z" clipRule="evenodd" />
                </svg>
            )
        },
    ];

    return (
        <footer className="bg-white border-t border-gray-200 py-12">
            <div className="container-custom">
                <div className="flex flex-col lg:flex-row justify-between gap-12">
                    {/* Brand and description */}
                    <div className="w-full lg:w-1/3">
                        <div className="flex items-center mb-6">
                            <span className="text-2xl font-bold text-gray-900">
                                Haru<span className="text-blue-600">Kuro</span>
                            </span>
                        </div>
                        <p className="text-gray-600 max-w-md mb-8">
                            The next generation crypto asset management platform. Harness the power of AI and advanced analytics to optimize your crypto portfolio.
                        </p>
                        <div className="flex space-x-5">
                            {socialLinks.map((social) => (
                                <motion.a
                                    key={social.name}
                                    href={social.href}
                                    className="text-gray-500 hover:text-blue-600 transition-colors"
                                    whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.9 }}
                                >
                                    <span className="sr-only">{social.name}</span>
                                    {social.icon}
                                </motion.a>
                            ))}
                        </div>
                    </div>

                    {/* Links */}
                    <div className="w-full lg:w-2/3 grid grid-cols-2 md:grid-cols-3 gap-8">
                        {footerLinks.map((group) => (
                            <div key={group.title}>
                                <h3 className="text-sm font-semibold text-gray-900 mb-4">{group.title}</h3>
                                <ul className="space-y-3">
                                    {group.links.map((link) => (
                                        <li key={link.name}>
                                            <motion.a
                                                href={link.href}
                                                className="text-gray-600 hover:text-blue-600 transition-colors text-sm"
                                                whileHover={{ x: 3 }}
                                            >
                                                {link.name}
                                            </motion.a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bottom section */}
                <div className="mt-12 pt-8 border-t border-gray-200">
                    <div className="text-gray-500 text-sm text-center">
                        &copy; {new Date().getFullYear()} HaruKuro. All rights reserved.
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer; 